import { IUser } from '../user';

export type { IUser };

export enum TokenType {
  actual,
  originating,
}

export enum TokenClass {
  apple = 'apple',
  email = 'email',
  facebook = 'facebook',
  google = 'googlejwt',
  scopedEmail = 'scoped_email',
  youversion = 'youversion',
}

export abstract class TokenParameters {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  abstract toStorageItem(user: IUser): any;
}

export abstract class Token {
  public readonly tokenType: TokenType;
  public readonly tokenClass: TokenClass;

  protected constructor(tokenType: TokenType, tokenClass: TokenClass) {
    this.tokenType = tokenType;
    this.tokenClass = tokenClass;
  }

  abstract get header(): string | null;

  abstract get token(): string | null;

  abstract get originatingId(): string | null;

  abstract get user(): IUser;
  abstract set user(user: IUser);

  abstract get expires(): number;

  abstract get refreshToken(): string | null;

  abstract get refreshable(): boolean;

  abstract get expired(): boolean;

  abstract get willExpireSoon(): boolean;

  abstract get initialized(): boolean;

  abstract get invalid(): boolean;

  abstract get scopes(): Array<string>;

  abstract refresh(): Promise<Token>;

  abstract expire(): Promise<void>;

  abstract setValid(): Promise<void>;

  abstract exchange(clientId: string, clientSecret: string, scopes: Array<string>): Promise<Token>;

  abstract toParameters(): TokenParameters;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  toStorageItem(): any {
    return this.toParameters().toStorageItem(this.user);
  }

  abstract initialize(originatingToken: Token | null, onRefreshed: (token: Token) => void): void;
}
